import { render, staticRenderFns } from "./WorkWithUs.vue?vue&type=template&id=3d97fcbe&scoped=true&"
import script from "./WorkWithUs.vue?vue&type=script&lang=ts&"
export * from "./WorkWithUs.vue?vue&type=script&lang=ts&"
import style0 from "./WorkWithUs.vue?vue&type=style&index=0&id=3d97fcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97fcbe",
  null
  
)

export default component.exports